import { render, staticRenderFns } from "./QuestionCardForMembership.vue?vue&type=template&id=1f852e38&"
import script from "./QuestionCardForMembership.vue?vue&type=script&lang=ts&"
export * from "./QuestionCardForMembership.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports